import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import {useSelector,useDispatch} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import {getRinglistorAll} from 'actions'

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function DialerRinglistor(props) {
     const classes = useStyles();
     const dispatch = useDispatch()
     const authUser = useSelector(state => state.auth.authUser)
     const RingListorA = useSelector(state=>state.RingList.RingListorA)
     const [currency, setCurrency] = React.useState(0);
     const handleChange = (event) => {
        setCurrency(event.target.value);
        props.handleChange("Ringlista",event.target.value)
    };
    React.useEffect(()=>{
        dispatch(getRinglistorAll(authUser.user_Afid,authUser.user_id))
    },[])
    return (
        <form className={classes.root}>
            <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                select
                label={<IntlMessages id="Calling.list"/>}
                variant="outlined"
                size="small"
                value={currency}
                fullWidth                            
                onChange={handleChange}
                SelectProps={{native: true,}}
                >
                    <option key={0} value={0}><IntlMessages id="Choose"/></option>
                    {
                        !isEmpty(RingListorA)?
                        RingListorA.map(item=>{
                            return <option key={item.id} value={item.id}>{item.KampanjName}</option>
                        })
                        :""
                    }
                </TextField>
            </div>
        </form>
    );
}

export default DialerRinglistor;